module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Mirror-36883dd71ac3da8473f28d2915f39bc7.svg";